import { render, staticRenderFns } from "./FormLabelSub.vue?vue&type=template&id=47503936&scoped=true&"
import script from "./FormLabelSub.vue?vue&type=script&lang=js&"
export * from "./FormLabelSub.vue?vue&type=script&lang=js&"
import style0 from "./FormLabelSub.vue?vue&type=style&index=0&id=47503936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47503936",
  null
  
)

export default component.exports